import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconChevronRight = ({
  width = 24,
  height = 24,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.96967 5.46967C9.26256 5.17678 9.73732 5.17678 10.0302 5.46967L16.0302 11.4697C16.3231 11.7626 16.3231 12.2373 16.0302 12.5302L10.0302 18.5302C9.73732 18.8231 9.26256 18.8231 8.96967 18.5302C8.67678 18.2373 8.67678 17.7626 8.96967 17.4697L14.4394 11.9999L8.96967 6.53022C8.67678 6.23732 8.67678 5.76256 8.96967 5.46967Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconChevronRight)
